module.exports = __webpack_public_path__ + "8971699fedcc42f55113697d4ff77ac8.mp4";